/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { DirectoriesRequestBuilderNavigationMetadata, type DirectoriesRequestBuilder } from './directories/index.js';
// @ts-ignore
import { FilesRequestBuilderNavigationMetadata, type FilesRequestBuilder } from './files/index.js';
// @ts-ignore
import { RevisionsRequestBuilderNavigationMetadata, type RevisionsRequestBuilder } from './revisions/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /shares
 */
export interface SharesRequestBuilder extends BaseRequestBuilder<SharesRequestBuilder> {
    /**
     * The directories property
     */
    get directories(): DirectoriesRequestBuilder;
    /**
     * The files property
     */
    get files(): FilesRequestBuilder;
    /**
     * The revisions property
     */
    get revisions(): RevisionsRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const SharesRequestBuilderUriTemplate = "{+baseurl}/shares";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const SharesRequestBuilderNavigationMetadata: Record<Exclude<keyof SharesRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    directories: {
        navigationMetadata: DirectoriesRequestBuilderNavigationMetadata,
    },
    files: {
        navigationMetadata: FilesRequestBuilderNavigationMetadata,
    },
    revisions: {
        navigationMetadata: RevisionsRequestBuilderNavigationMetadata,
    },
};
/* tslint:enable */
/* eslint-enable */
